module.exports = __webpack_public_path__ + "static/media/screenshot_customize_your_character.719a26f3.png";